import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'app-tiedoston-sivut',
  templateUrl: './tiedoston-sivut.component.html',
  styleUrls: ['./tiedoston-sivut.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TiedostonSivutComponent {
  private _kuvaUrlit: string[] = []

  @Input()
  set kuvaUrlit(kuvaUrlit: string[]) {
    const uudet = kuvaUrlit ?? []
    if (uudet.length !== this._kuvaUrlit.length || uudet.some((url, indeksi) => url !== this._kuvaUrlit[indeksi])) {
      this.sivuIndeksi = 0
    }
    this._kuvaUrlit = uudet
  }
  get kuvaUrlit() {
    return this._kuvaUrlit
  }

  sivuIndeksi = 0

  edellinenSivu() {
    if (this.sivuIndeksi > 0) {
      this.sivuIndeksi--
    }
  }

  seuraavaSivu() {
    if (this.sivuIndeksi < this._kuvaUrlit.length - 1) {
      this.sivuIndeksi++
    }
  }
}
